import { apiClient } from '../../../../lib/api/client';
import {
  isClosedStageCategory,
  normalizeLeadPipelineStageDetail,
  normalizeLeadPipelineStageListItem,
  sortLeadPipelineStages,
} from '../stageMetadata';
import type {
  LeadPipelineStageDetail,
  LeadPipelineStageFormValues,
  LeadPipelineStageListItem,
} from '../types';

export async function getLeadPipelineStages(): Promise<LeadPipelineStageListItem[]> {
  const response = await apiClient.get<LeadPipelineStageListItem[]>('/settings/lead-pipeline-stages');
  const items = response.data.map((item) => normalizeLeadPipelineStageListItem(item));
  return sortLeadPipelineStages(items);
}

export async function getLeadPipelineStageById(id: number): Promise<LeadPipelineStageDetail> {
  const response = await apiClient.get<LeadPipelineStageDetail>(`/settings/lead-pipeline-stages/${id}`);
  return normalizeLeadPipelineStageDetail(response.data);
}

export async function createLeadPipelineStage(
  data: LeadPipelineStageFormValues,
): Promise<{ id: number }> {
  console.log('createLeadPipelineStage data:', data);
  console.log('category:', data.category, 'isClosed:', isClosedStageCategory(data.category));
  console.log('closingStatus value:', data.closingStatus, 'type:', typeof data.closingStatus);
  const body = {
    label: data.label,
    sortOrder: data.sortOrder,
    category: data.category,
    closingStatus: isClosedStageCategory(data.category) ? data.closingStatus ?? null : null,
    isActive: data.isActive,
  };
  console.log('request body:', body);
  const response = await apiClient.post<{ id: number }>('/settings/lead-pipeline-stages', body);
  return response.data;
}

export async function deleteLeadPipelineStage(id: number): Promise<void> {
  await apiClient.delete(`/settings/lead-pipeline-stages/${id}`);
}

export async function updateLeadPipelineStage(
  id: number,
  data: LeadPipelineStageFormValues,
): Promise<void> {
  await apiClient.put(`/settings/lead-pipeline-stages/${id}`, {
    code: data.code,
    label: data.label,
    sortOrder: data.sortOrder,
    category: data.category,
    closingStatus: isClosedStageCategory(data.category) ? data.closingStatus ?? null : null,
    isActive: data.isActive,
  });
}
